import React, { useState, useEffect } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../pages/login/AccessToken";
import axios from "axios";
import {
  Box,
  Button,
  Card,
  Grid,
  Icon,
  IconButton,
  Typography,
} from "@mui/material";
import { SaveAlt } from "@mui/icons-material";
import { Select } from "antd";
import "../../pages/hlthtek-demo/components/UserComponents.scss";
import RefreshIcon from "@mui/icons-material/Refresh";

import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";
// import { CustomStyledButtonSolid } from "../../pages/doctor-console/StyledComponents";
import { formatDateIST } from "../../pages/doctor-console/Utils/UtilsFunctions";
// import { TableHead } from "@mui/material";

function ScanShareRecords() {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setError,
    getValues,
    setValue,
  } = useForm();

  const [displayExistingDetails, setDisplayExistingDetails] = useState(false);
  const [scanShareRecords, setScanShareRecords] = useState(false);
  
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );

  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const getScanShareRecords = (data, e) => {
    e.preventDefault();
    // console.log(data);
    if (Token()) {
      var post_data = {};

      post_data.start_date = data.start_datetime;
      post_data.end_date = data.end_datetime;

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_scan_share_token_details/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status === "Success") {
            // console.log("Scan-Share Data", res.data);
            setScanShareRecords(res.data);
            setDisplayExistingDetails(true);
          } else {
            toast.success(res.data.message);
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };
  const getRowClassName = (params) => {
    return "custom-row";
  };
  const columns = [
    { field: "id", headerName: "Sl. No." },
    { field: "patient_id", headerName: "Patient ID", width: 100 },
    { field: "name", headerName: "Patient name", width: 160 },
    { field: "phone", headerName: "Phone", width: 120 },
    { field: "gender", headerName: "Gender", width: 80 },
    { field: "age", headerName: "Age", width: 50 },
    { field: "dob", headerName: "DOB", width: 100 },
    { field: "token", headerName: "Token", width: 80 },
    { field: "abha_no", headerName: "ABHA Number", width: 150 },
    { field: "abha_id", headerName: "ABHA Address", width: 160 },
    { field: "facility_name", headerName: "Facility Name", width: 200 },
    { field: "date_of_creation", headerName: "Date of Creation", width: 250 },
    { field: "status", headerName: "Status", width: 100 },
  ];

  const rows = scanShareRecords
    ? scanShareRecords.scan_share_token_list.map((item, index) => {
        return {
          id: index + 1,
          // facility_id: item.facility_id ?? "-",
          patient_id: item.patient_id ?? "-",
          status: item.status ?? "-",
          token: item.token ?? "-",
          name: item.name ?? "-",
          gender: item.gender ?? "-",
          age: item.age ?? "-",
          phone: item.phone ?? "-",
          abha_no:
            item.abha_no !== null && item.abha_no.length > 0
              ? item.abha_no
              : "Not Available",
          abha_id:
            item.abha_id !== null && item.abha_id.length > 0
              ? item.abha_id
              : "Not Available",
          facility_name: item.facility_name ?? "-",
          dob: item.dob ?? "-",
          // unique_id: item.unique_id ? item.unique_id : "-",
          date_of_creation: item.date_of_creation
            ? formatDateIST(item.date_of_creation)
            : "-",
        };
      })
    : [];

  // Now `rows` contains the transformed transaction details.

  const generatePdf = () => {
    const doc = new jsPDF();
    let tableHeaders, tableData;

    tableHeaders = columns.map((column) => column.headerName);
    tableData = rows.map((row) => columns.map((column) => row[column.field]));

    doc.setFontSize(12);

    doc.text("Scan & Share Records", 10, 10);

    doc.autoTable({
      head: [tableHeaders],
      body: tableData,
      startY: 20,
      styles: { fontSize: 10, textColor: [0, 0, 0] },
    });

    doc.save("scan_share_records.pdf");
  };
  const generateCsvData = () => {
    const headers = columns.map((column) => column.headerName);
    const csvData = [
      headers,
      ...rows.map((row) => columns.map((column) => row[column.field])),
    ];
    return csvData;
  };
  useEffect(() => {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`; // Format for input value (yyyy-mm-dd)
    };

    setValue("start_datetime", formatDate(firstDayOfMonth));
    setValue("end_datetime", formatDate(lastDayOfMonth));
  }, []);

  return (
    <>
      {/* <div style={{ width: '60vw' }} > */}

      <Box
        sx={{
          //   position: "absolute",
          //   top: "50%",
          //   left: "50%",
          //   transform: "translate(-50%, -50%)",
          width: { xs: "80%", sm: "60%", md: "60%" },
          maxWidth: "900px",
          overflowY: "auto",
          p: "28px 24px",
          background: "transparent",
          boxShadow: "none", // remove outer box shadow
          border: "none",
          margin: "auto",
          mb: 2,
        }}
      >
        <Card
          sx={{
            backgroundColor: "#FDFDFD",
            borderRadius: "12px",
            width: "100%",
            p: 0,
            border: "1px solid #E5E7EB",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.08)",
          }}
        >
            {/* Top header bar */}
            <Box
              sx={{
              backgroundColor: "#213360",
                color: "#FFFFFF",
              px: "24px",
              
              minHeight: "72px",
              display: "flex",
              alignItems: "center",
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                borderBottom: "1px solid rgba(255,255,255,0.15)",
              }}
           >
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#FFFFFF", fontSize: "16px" }}>
                Get Scan & Share Records
              </Typography>
            </Box>
            {/* <div
              className="contact-panel mb-50 m-auto"
              // style={{ width: "60vw" }}
            > */}
            <Box sx={{ px: 3, py: 3 }}>
              <form
                className="contact-panel__form"
                onSubmit={handleSubmit(getScanShareRecords)}
              >
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <label style={{ color: "#495057" }}>Start Date</label>
                  <div className="form-group form-group-date">
                    <i className="icon-calendar form-group-icon"></i>
                    <input
                      type="date"
                      // className="form-control"
                      className="form-control main-form-select"
                      name="start_datetime"
                      {...register("start_datetime", {
                        required: "Start Date is required.",
                      })}
                    />
                    {errors.start_date && (
                      <p className="errorMsg">{errors.start_date.message}</p>
                    )}
                  </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-6">
                  <label style={{ color: "#495057" }}>End Date</label>
                  <div className="form-group form-group-date">
                    <i className="icon-calendar form-group-icon"></i>
                    <input
                      type="date"
                      // className="form-control"
                      className="form-control main-form-select"
                      placeholder="Enter End Date"
                      name="end_datetime"
                      {...register("end_datetime", {
                        required: "End Date is required.",
                      })}
                    />
                    {errors.end_date && (
                      <p className="errorMsg">{errors.end_date.message}</p>
                    )}
                  </div>
                </div>
              </div>

              <input
                type="hidden"
                name="recordType"
                {...register("recordType")} // Assuming you're using react-hook-form
              />

                <div className="row justify-content-center">
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <button
                      type="submit"
                      name="recordType"
                      value="scan_share"
                      className="btn btn__secondary btn__rounded btn__block mt-2"
                      onClick={() => {
                        setValue("recordType", "scan_share");
                      }}
                    >
                      <span>Get Scan & Share Records</span>{" "}
                      <i className="icon-arrow-right"></i>
                    </button>
                  </div>
                </div>

              {/* <input type="hidden" name="recordType" ref={register} /> */}
              <div className="contact-result"></div>
              </form>
            </Box>
            {/* </div> */}
        </Card>
      </Box>

      {/* {displayExistingDetails && (
        <div className="contact-panel mb-50 m-auto" style={{ width: "60vw" }}>
          <div
            // style={{
            //   backgroundColor: "#f5f5f5",
            //   borderRadius: "8px",
            //   padding: "20px",
            //   display: "flex",
            //   alignItems: "center",
            //   gap: "15px",
            //   boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            // }}
          >
            
              <Icon name="scanandshareicon" size={24} />
            
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#000",
                }}
              >
                Total Records:
              </span>
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "#000",
                }}
              >
                {scanShareRecords !== undefined
                  ? scanShareRecords.scan_share_token_list.length
                  : "0"}
              </span>
            </div>
          </div>
        </div>
      )} */}

      {displayExistingDetails && (
        <div
          className="contact-panel mb-5 m-auto"
          style={{
            width: "57vw",
            display: "flex",
            flexDirection: "row",
            padding: "30px",
          }}
        >
          {/* Icon on left */}
          <Icon name="scanandshareicon" size={28} />

          {/* Text + Count */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#000",
              }}
            >
              Total Records:
            </span>
            <span
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#000",
              }}
            >
              {scanShareRecords !== undefined
                ? scanShareRecords.scan_share_token_list.length
                : "0"}
            </span>
          </div>
        </div>
      )}

      {/* </div> */}
      {displayExistingDetails ? (
        <div style={{ paddingTop: "3%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "auto",
              width: "100%",
              maxWidth: "1200px", // Set a max width for large screens
              padding: "1rem",
            }}
          >
            <div className="main-title" style={{ textAlign: "center" }}>
              Scan & Share Records List
            </div>
            <div style={{ width: "100%" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                components={{
                  Toolbar: () => (
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{
                        mb: 2,
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={8}
                        sx={{ display: "flex", gap: 1 }}
                      >
                        <GridToolbarColumnsButton />
                        <GridToolbarFilterButton />
                        <GridToolbarDensitySelector />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        sx={{
                          display: "flex",
                          gap: 1,
                          justifyContent: { xs: "center", sm: "flex-end" },
                        }}
                      >
                        <Button
                          variant="text"
                          color="primary"
                          onClick={() => generatePdf()}
                          startIcon={<SaveAlt />}
                        >
                          Download PDF
                        </Button>
                        <CSVLink
                          data={generateCsvData()}
                          filename={"scan_share_records.csv"}
                          target="_blank"
                        >
                          <Button
                            variant="text"
                            color="primary"
                            startIcon={<SaveAlt />}
                          >
                            Download CSV
                          </Button>
                        </CSVLink>
                      </Grid>
                    </Grid>
                  ),
                }}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 10 },
                  },
                }}
                pageSizeOptions={[5, 10]}
                getRowClassName={getRowClassName}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "1px solid #e0e0e0",
                    borderRadius: "4px",
                    fontFamily: "Arial, sans-serif",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#125386",
                    color: "white",
                    fontSize: "13px",
                    fontWeight: "600",
                    minHeight: "48px !important",
                    "& .MuiDataGrid-columnHeaderTitle": {
                      color: "white",
                      fontWeight: "600",
                      fontSize: "13px",
                    },
                    "& .MuiDataGrid-columnHeader": {
                      borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                      padding: "0 12px",
                    },
                    "& .MuiDataGrid-columnHeader:last-child": {
                      borderRight: "none",
                    },
                    "& .MuiDataGrid-iconButtonContainer": {
                      color: "white",
                    },
                    "& .MuiDataGrid-menuIcon": {
                      color: "white",
                    },
                    "& .MuiDataGrid-sortIcon": {
                      color: "white",
                    },
                    "& .MuiDataGrid-columnHeaderSortable": {
                      "& .MuiDataGrid-sortIcon": {
                        color: "white",
                      },
                    },
                    "& .MuiDataGrid-columnHeaderTitleContainer": {
                      "& .MuiDataGrid-sortIcon": {
                        color: "white",
                      },
                    },
                    "& .MuiSvgIcon-root": {
                      color: "white",
                    },
                  },
                  "& .MuiDataGrid-row": {
                    backgroundColor: "white",
                    minHeight: "40px !important",
                    "&:nth-of-type(even)": {
                      backgroundColor: "white",
                    },
                    "&:hover": {
                      backgroundColor: "#f8f9fa",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#e3f2fd",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                      },
                    },
                    borderBottom: "1px solid #e0e0e0",
                  },
                  "& .MuiDataGrid-cell": {
                    borderRight: "1px solid #e0e0e0",
                    fontSize: "12px",
                    color: "#374151",
                    padding: "8px 12px",
                    minHeight: "40px !important",
                    "&:last-child": {
                      borderRight: "none",
                    },
                    "&:focus": {
                      outline: "none",
                    },
                  },
                  "& .MuiDataGrid-cellContent": {
                    fontSize: "12px",
                    color: "#374151",
                    fontWeight: "400",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    backgroundColor: "#f8f9fa",
                    borderTop: "1px solid #e0e0e0",
                    minHeight: "52px",
                  },
                  "& .MuiTablePagination-root": {
                    color: "#374151",
                    fontSize: "12px",
                  },
                  "& .MuiDataGrid-toolbarContainer": {
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #e0e0e0",
                    padding: "8px 16px",
                  },
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        []
      )}
    </>
  );
}

export default ScanShareRecords;
